// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"CreateEditDiscountPackage_closeAlertButton__2qfPx"};